import React, { useMemo } from "react";
import { EChartsOption } from "echarts";
import ReactEchart from "../../../../../../molecules/ReactEchart";

const LineChart: React.FC = React.memo(() => {
  const options = useMemo<EChartsOption>(
    () => ({
      tooltip: {
        trigger: "axis",
        backgroundColor: "#fff",
        borderColor: "#ddd",
        borderWidth: 1,
        textStyle: {
          color: "#000",
        },
        axisPointer: {
          type: "line",
          lineStyle: {
            type: "dashed",
            color: "#999",
          },
        },
      },
      grid: {
        left: "3%",
        right: "3%",
        bottom: 50,
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: [
          "JAN",
          "FEB",
          "MAR",
          "APR",
          "MAY",
          "JUN",
          "JUL",
          "AUG",
          "SEP",
          "OCT",
          "NOV",
          "DEC",
        ],
        axisLine: { show: true },
        axisTick: { show: false },
        boundaryGap: true,
        axisLabel: {
          interval: window.innerWidth < 768 ? 1 : 0,
          rotate: window.innerWidth < 768 ? 40 : 0,
          padding: [5, 5, 15, 5],
        },
      },
      yAxis: {
        type: "value",
        splitLine: { show: false },
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
      },
      series: [
        {
          name: "Cases",
          type: "line",
          smooth: true,
          data: [
            3500, 2800, 2500, 3200, 4500, 7000, 5000, 3000, 6000, 4000, 5500,
            4800,
          ],
          lineStyle: {
            color: "#145b7d",
            width: 3,
          },
          itemStyle: {
            color: "#145b7d",
            borderWidth: 2,
          },
          symbol: "circle",
          symbolSize: 8,
          showSymbol: false,
          emphasis: {
            focus: "series",
            itemStyle: {
              color: "#145b7d",
              borderWidth: 2,
            },
            showSymbol: true,
          },
          areaStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: "rgba(20, 91, 125, 0.4)" },
                { offset: 1, color: "rgba(255, 255, 255, 0)" },
              ],
            },
          },
        },
      ],
      dataZoom: [
        {
          type: "inside",
          start: 0,
          end: 100,
        },
        {
          type: "slider",
          show: true,
          start: 0,
          end: 100,
          bottom: 5,
        },
      ],
    }),
    []
  );

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "900px",
        height: "389px",
        margin: "auto",
        display: "flex",
        alignItems: "end",
      }}
    >
      <ReactEchart
        options={options}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
});

export default LineChart;
